export default {
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
  iconCol: {
    width: 80,
  },
  nameCol: {

  },
  quantityCol: {
    display: 'flex',
    alignItems: 'center',
    width: 150,
  },
  actionCol: {
    width: 80,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfileDialog/ItemTypesGrid/styles.js